import { ApiService } from '../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigProductService {
    constructor(private apiService: ApiService) {
    }
    GetProductGroup(str) {
        if (str != null) {
            return this.apiService.post('ENTigerFlowStaging/api/mvp/product/group/websearch/' + str, null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "error";
                }
                );
        }
        else {
            return this.apiService.post('ENTigerFlowStaging/api/mvp/product/group/websearch/', null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "error";
                }
                );
        }
    }

    EditProductGroup(obj) {
        return this.apiService.post('ENTigerFlowStaging/api/mvp/product/group/webedit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    CreateProductGroup(obj) {
        return this.apiService.post('ENTigerFlowStaging/api/mvp/product/group/webcreate', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    codeGen(obj) {
        return this.apiService.get('ENTigerFlowStaging/api/mvp/product/group/GenerateCode?ProductGroupName=' + obj)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    DeleteProductGroup(obj) {
        return this.apiService.post('ENTigerFlowStaging/api/mvp/department/DeleteProductGroup', obj)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetProducts(str) {
        if (str != null) {
            return this.apiService.post('ENTigerFlowStaging/api/mvp/product/SearchProduct?Search=' + str, null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "error";
                }
                );
        }
        else {
            return this.apiService.post('ENTigerFlowStaging/api/mvp/product/SearchProduct?Search=', null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "error";
                }
                );
        }
    }

    GetSubProducts(str) {
        if (str != null) {
            return this.apiService.post('ENTigerFlowStaging/api/mvp/subproduct/Search?search=' + str, null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "e";
                }
                );
        }
        else {
            return this.apiService.post('EENTigerFlowStaging/api/mvp/subproduct/Search?search=', null)
                .map(
                data => {
                    return data;
                }
                ).catch(
                (error: Response) => {
                    return "e";
                }
                );
        }
    }

    //Product Service Start
    EditProduct(obj) {
        return this.apiService.post('ENTigerFlowStaging/api/mvp/product/EditProduct', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e ";
            }
            );
    }

    CreateProduct(obj) {
        return this.apiService.post('ENTigerFlowStaging/api/mvp/product/CreateProduct', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }
    // Product Services End
}


// WEBPACK FOOTER //
// ./src/app/system_setting/configure_product/config_product.service.ts